import { Reducer } from 'interfaces'
import { createEmptyFetchable, createFetchableReducer } from 'helpers/loadableHelpers'
import { GetMeetingVideoDetailsAction } from 'components/features/coaching/advisorVideoCall/types/actions'
import { combineReducers } from 'redux'
import { VideoCallDetailsDateState } from 'components/features/coaching/advisorVideoCall/types/state'

const fetchableRequestReducer = createFetchableReducer<null>()
const request: Reducer<VideoCallDetailsDateState['request']> = (prevState = createEmptyFetchable(), action) => {
  switch (action.type) {
    case GetMeetingVideoDetailsAction.type:
      return fetchableRequestReducer(prevState, action)
  }
  return prevState
}

const details: Reducer<VideoCallDetailsDateState['details']> = (prevState = null, action) => {
  switch (action.type) {
    case GetMeetingVideoDetailsAction.type: {
      if (action.meta !== 'success') {
        return prevState
      }

      return action.payload.response
    }
  }
  return prevState
}


export const videoCallDetailsReducer = combineReducers<VideoCallDetailsDateState>({
  request,
  details,
})
